// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"3a9aabdf","177":"8632fdff","276":"516de9a8","336":"7e940733","348":"a6fe3b69","373":"292b9c25","458":"93c8438f","488":"897f52e6","561":"5d479a7e","716":"ca6883ad","894":"e8527090","905":"9e177b24","951":"199ed30f","959":"8a608ab1","967":"f3891305"}[chunkId] + ".chunk.js";
};